import React, { useState, useEffect, useRef } from "react";
import Header from "../../Common/Layout/Header";
import "flatpickr/dist/themes/material_blue.css";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../Common/Configurations/AuthContext";
import apiService from "../../Common/Configurations/APIService";
import config from "../../Common/Configurations/APIConfig";
import SightSeeingTabs from "../AllTabs/SightSeeingTabs";
import "react-multi-carousel/lib/styles.css";
import moment from "moment";
import DefaultData from "../../CompanyData/DefaultData";
const SightSeeingBooking = () => {
  const { user, loading } = useAuth();
  const { state } = useLocation();
  const params = useParams();
  const navigate = useNavigate();
  const [searchData, setSearchData] = useState({});
  const [product, setProduct] = useState({});
  const [adultTravellers, setAdultTravellers] = useState([]);
  const [kidTravellers, setKidTravellers] = useState([]);
  const [infantTravellers, setInfantTravellers] = useState([]);
  const [totalTravellers, setTotalTravellers] = useState(0);
  const [email, setEmail] = useState(user?.email);
  const [mobile, setMobile] = useState(user?.phoneNumber);
  const [errors, setErrors] = useState({});
  const [markup, setMarkup] = useState(0);
  const [pageLoading, setPageLoading] = useState(false);
  function getformtravelData(tData) {
    var gender = "MALE";
    if (tData.title === "Mr") {
      gender = "MALE";
    } else if (tData.title === "Mrs") {
      gender = "FEMALE";
    } else if (tData.title === "Ms") {
      gender = "FEMALE";
    } else if (tData.title === "Master") {
      gender = "MALE";
    }
    const myObject = {
      travelerId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      firstName: tData.firstName,
      lastName: tData.lastName,
      title: tData.title,
      gender: gender,
      travelerType: tData.type,
      //dateOfBirth: moment(tData.dateOfBirth).format('YYYY-MM-DD'),
      dateOfBirth:
        params.isDomestic === "INTERNATIONAL"
          ? moment(tData.dateOfBirth).format("YYYY-MM-DD")
          : moment(new Date()).format("YYYY-MM-DD"),
      passportNo: tData.passportNo,
      passportNationality: tData.passportNationality,
      passbookIssueDate: tData.passbookIssueDate ? moment(tData.passbookIssueDate).format("YYYY-MM-DD") : null,
      passbookExpireDate: tData.passbookExpireDate ? moment(tData.passbookExpireDate).format("YYYY-MM-DD") : null,
    };
    return myObject;
  }
  const validate = (index, adata) => {
    let temp = {};
    temp.firstName = adata.firstName === "" ? false : true;
    temp.lastName = adata.lastName === "" ? false : true;
    if (params.isDomestic === "INTERNATIONAL") {
      temp.dateOfBirth = adata.dateOfBirth === "" ? false : true;
      temp.passportNo = adata.passportNo === "" ? false : true;
      temp.passportNationality =
        adata.passportNationality === "" ? false : true;
      temp.passbookIssueDate = adata.passbookIssueDate === "" ? false : true;
      temp.passbookExpireDate = adata.passbookExpireDate === "" ? false : true;
    }
    temp.email = email === "" ? false : true;
    temp.mobile = mobile === "" ? false : true;
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };
  const handleAdultChange = (index, event) => {
    const values = [...adultTravellers];
    const updatedValue = event.target.name;
    values[index][updatedValue] = event.target.value;
    setAdultTravellers(values);
  };
  const handleKidsChange = (index, event) => {
    const values = [...kidTravellers];
    const updatedValue = event.target.name;
    values[index][updatedValue] = event.target.value;
    setKidTravellers(values);
  };
  const handleInfantChange = (index, event) => {
    const values = [...infantTravellers];
    const updatedValue = event.target.name;
    values[index][updatedValue] = event.target.value;
    setInfantTravellers(values);
  };
  const [errorAdult, setAdultError] = useState("");
  const [errorKid, setKidError] = useState("");
  const [errorInfant, setInfantError] = useState("");
  const validateAdultDate = (index, event) => {
    const inputDate = new Date(event.target.value);
    const year = inputDate.getFullYear().toString();
    const currentYear = new Date().getFullYear();
    const minYear = currentYear - 100;
    if (year.length > 4 && event.target.value) {
      setAdultError("The year must be 4 digits!");
      event.target.value = ""; // Clear the input value
    }
    if (year < minYear || year > currentYear) {
      setAdultError(`The year must be between ${minYear} and ${currentYear}!`);
      event.target.setCustomValidity(
        `The year must be between ${minYear} and ${currentYear}`
      );
      event.target.value = ""; // Clear the input value
    } else {
      const values = [...adultTravellers];
      const updatedValue = event.target.name;
      values[index][updatedValue] = event.target.value;
      setAdultTravellers(values);
      setAdultError("");
    }
  };
  const validateKidsDate = (index, event) => {
    const inputDate = new Date(event.target.value);
    const year = inputDate.getFullYear().toString();
    const currentYear = new Date().getFullYear();
    const minYear = currentYear - 12;
    if (year.length > 4 && event.target.value) {
      setKidError("The year must be 4 digits!");
      event.target.value = ""; // Clear the input value
    }
    if (year < minYear || year > currentYear) {
      setKidError(`The year must be between ${minYear} and ${currentYear}!`);
      event.target.setCustomValidity(
        `The year must be between ${minYear} and ${currentYear}`
      );
      event.target.value = ""; // Clear the input value
    } else {
      const values = [...kidTravellers];
      const updatedValue = event.target.name;
      values[index][updatedValue] = event.target.value;
      setKidTravellers(values);
      setKidError("");
    }
  };
  const validateInfantDate = (index, event) => {
    const inputDate = new Date(event.target.value);
    const year = inputDate.getFullYear().toString();
    const currentYear = new Date().getFullYear();
    const minYear = currentYear - 2;
    if (year.length > 4 && event.target.value) {
      setInfantError('The year must be 4 digits!');
      event.target.value = ''; // Clear the input value
    }
    if (year < minYear || year > currentYear) {
      setInfantError(`The year must be between ${minYear} and ${currentYear}!`);
      event.target.setCustomValidity(`The year must be between ${minYear} and ${currentYear}`);
      event.target.value = ''; // Clear the input value
    }
    else {
      const values = [...infantTravellers];
      const updatedValue = event.target.name;
      values[index][updatedValue] = event.target.value;
      setInfantTravellers(values);
      setInfantError('');
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setPageLoading(true);
    var temptravellerinfos = [];
    for (var i = 0; i < adultTravellers.length; i++) {
      if (validate(i, adultTravellers[i])) {
        var tempData = getformtravelData(adultTravellers[i]);
        temptravellerinfos = [...temptravellerinfos, tempData];
      }
    }
    for (var i = 0; i < kidTravellers.length; i++) {
      if (validate(i, kidTravellers[i])) {
        var tempData = getformtravelData(kidTravellers[i]);
        temptravellerinfos = [...temptravellerinfos, tempData];
      }
    }
    for (var i = 0; i < infantTravellers.length; i++) {
      if (validate(i, infantTravellers[i])) {
        var tempData = getformtravelData(infantTravellers[i]);
        temptravellerinfos = [...temptravellerinfos, tempData];
      }
    }
    if (errorAdult !== "" || errorKid !== "" || errorInfant !== "") {
      alert("Please check the errors");
    } else if (temptravellerinfos.length === totalTravellers) {
      searchData.travellerInfos = temptravellerinfos;
      displayRazorpay(searchData);
    } else {
      setPageLoading(false);
      alert("Please enter travelers data");
    }
  };
  function loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }
  async function displayRazorpay(searchData) {
    const res = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!res) {
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }
    const result = await apiService.post(
      config.MAKEPAYMENT +
      "?Amount=" +
      Math.round(searchData.totalPrice) +
      "&PayRequest=RAZORPAY&CompanyId=" +
      user?.cid
    );
    if (!result) {
      alert("Server error. Are you online?");
      return;
    }
    // Getting the order details back
    if (result.succeeded) {
      const { amount, id: order_id, currency, razorpayKey, name } = result.data;
      const options = {
        key: razorpayKey, // Enter the Key ID generated from the Dashboard
        amount: amount,
        currency: currency,
        name: name,
        description: "SightSeeing Booking Fee",
        order_id: order_id,
        handler: async function (response) {
          InsertBooking(razorpayKey, searchData);
        },
        prefill: {
          name:
            searchData.travellerInfos[0].firstName +
            " " +
            searchData.travellerInfos[0].lastName,
          email: user?.email,
          contact: user?.phoneNumber,
        },
        notes: {
          address: user?.city,
        },
        theme: {
          color: "#61dafb",
        },
      };
      const paymentObject = new window.Razorpay(options);
      paymentObject.open();
    } else {
      alert("Payment failed. Please try again");
    }
  }

  const InsertBooking = async (paymentGatewayNo, searchData) => {
    searchData.transactionNo = paymentGatewayNo;
    searchData.paymentStatus = "SUCCESS";
    searchData.bookingStatus = "CONFIRMED";
    searchData.paymentGatewayNo = paymentGatewayNo;
    searchData.noOfAdults = parseInt(params.adults, 10);
    searchData.noOfKids = parseInt(params.kids, 10);
    searchData.noOfInfants = parseInt(params.infants, 10)
    searchData.totalPrice = parseFloat(searchData.totalPrice);
    searchData.gatewayAmount = searchData.totalPrice;
    searchData.walletAmount = 0;
    searchData.creditAmount = 0;
    searchData.markup = parseFloat(markup);
    searchData.customerPrice = parseFloat(searchData.customerPrice);
    searchData.email = email;
    searchData.mobile = mobile;
    searchData.paymentGateway = "RAZORPAY";
    searchData.userId = user?.id;
    searchData.branchId = user?.bId;

    searchData.requestedBy = DefaultData.USERTYPE;
    searchData.productURL = searchData?.productURL;
    searchData.product = product;

    var response = await apiService.post(config.SIGHTSEEINGBOOK, searchData);

    console.log(response);
    if (response.succeeded) {
      setPageLoading(false);
      navigate("/sightseeing/booking/" + response.data.sightSeeingBookingId);
    } else {
      setPageLoading(false);
      alert("Error in booking confirmation. Please contact admin");
    }
  };
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };
  const handleMobileChange = (e) => {
    setMobile(e.target.value);
  };
  useEffect(() => {
    if (state === null) {
      navigate("/search-activities");
    } else if (params === null) {
      navigate("/search-activities");
    } else if (state.searchQuery === null) {
      navigate("/search-activities");
    } else {
      setPageLoading(false);
      setSearchData(state.searchQuery);
      setProduct(state.productQuery);
      console.log(state.product);
      setTotalTravellers(parseInt(params.adults) + parseInt(params.kids) + parseInt(params.infants));
      if (user) {
        setMarkup(user.sightseeingMarkup || 0);
      }
      const avalues = [...adultTravellers];
      if (adultTravellers.length < params.adults) {
        for (var i = 0; i < params.adults; i++) {
          avalues.push({
            title: "Mr",
            firstName: "",
            lastName: "",
            type: "ADULT",
            dateOfBirth: "",
            passportNo: "",
            passportNationality: "IN",
            passbookIssueDate: "",
            passbookExpireDate: "",
          });
          setAdultTravellers(avalues);
        }
      }
      //setTotalKids(params.kids)
      const kvalues = [...kidTravellers];
      if (kidTravellers.length < params.kids) {
        for (var i = 0; i < params.kids; i++) {
          kvalues.push({
            title: "Master",
            firstName: "",
            lastName: "",
            type: "CHILD",
            dateOfBirth: "",
            passportNo: "",
            passportNationality: "IN",
            passbookIssueDate: "",
            passbookExpireDate: "",
          });
          setKidTravellers(kvalues);
        }
      }
      const ivalues = [...infantTravellers];
      if (infantTravellers.length < params.infants) {
        for (var i = 0; i < params.infants; i++) {
          ivalues.push({ title: "Master", firstName: "", lastName: "", type: "INFANT", dateOfBirth: "", passportNo: "", passportNationality: "IN", passbookIssueDate: "", passbookExpireDate: "" });
          setInfantTravellers(ivalues);
        }
      }
    }
  }, []);
  if (loading) return <p>Loading...</p>;
  if (!user) {
    navigate("/");
  }
  return (
    <div id="layout-wrapper">
      <Header User={user} activeSection="sightseeing" />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="card pt-0">
              <div className="p-2">
                <SightSeeingTabs pageName="SEARCH" />
              </div>
              <div className="card-body">
                {pageLoading === true ? (
                  <div className="text-center">
                    <img
                      src="/assets/images/loader.webp"
                      width={"64px"}
                      height={"64px"}
                    ></img>
                    Loading, Please wait...
                  </div>
                ) : (
                  <div className="row">
                    <div className="col-lg-8">
                      <div className="card-header">
                        <h6 className="fw-semibold mb-0">Traveler Details</h6>
                      </div>
                      <div className="card-body">
                        <div className="bg-success bg-opacity-10 rounded-2 p-3 mb-3">
                          <p className="h6 text-md mb-0">
                            <span className="badge bg-success me-2">New</span>
                            Please enter your name as per your passport ID
                          </p>
                        </div>
                        <div className="full-width d-flex flex-column mb-4 position-relative">
                          <div className="row align-items-stat">
                            {adultTravellers.length > 0 &&
                              adultTravellers.map((adult, index) => (
                                <div>
                                  <p className="fw-600">
                                    Adult {parseInt(index + 1)}
                                  </p>
                                  <div className="row g-3 mb-4">
                                    <div className="col-sm-2">
                                      <labe>Title</labe>
                                      <select
                                        className="form-control"
                                        name="title"
                                        required
                                        value={adult.title}
                                        onChange={(event) =>
                                          handleAdultChange(index, event)
                                        }
                                      >
                                        <option value="Mr">Mr</option>
                                        <option value="Mrs">Mrs</option>
                                        <option value="Ms">Ms</option>
                                        <option value="Master">Master</option>
                                      </select>
                                      {errors.title === false ? (
                                        <div className="validationerror">
                                          Please select title{" "}
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                    <div className="col-sm-5">
                                      <labe>Givenname</labe>
                                      <input
                                        className="form-control"
                                        name="firstName"
                                        value={adult.firstName}
                                        onChange={(event) =>
                                          handleAdultChange(index, event)
                                        }
                                        required
                                        placeholder="Enter First Name"
                                        type="text"
                                      />
                                      {errors.firstName === false ? (
                                        <div className="validationerror">
                                          Please enter firstName{" "}
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                    <div className="col-sm-5">
                                      <labe>Surname</labe>
                                      <input
                                        className="form-control"
                                        name="lastName"
                                        value={adult.lastName}
                                        onChange={(event) =>
                                          handleAdultChange(index, event)
                                        }
                                        required
                                        placeholder="Enter Surname"
                                        type="text"
                                      />
                                      {errors.lastName === false ? (
                                        <div className="validationerror">
                                          Please enter surname{" "}
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  </div>
                                </div>
                              ))}
                            {kidTravellers.length > 0 &&
                              kidTravellers.map((adult, index) => (
                                <div>
                                  <p className="fw-600">
                                    CHILD {parseInt(index + 1)}
                                  </p>
                                  <div className="row g-3 mb-3">
                                    <div className="col-sm-2">
                                      <label>Title</label>
                                      <select
                                        className="form-control"
                                        name="title"
                                        required
                                        value={adult.title}
                                        onChange={(event) =>
                                          handleKidsChange(index, event)
                                        }
                                      >
                                        <option value="Ms">Ms</option>
                                        <option value="Master">Master</option>
                                      </select>
                                      {errors.title === false ? (
                                        <div className="validationerror">
                                          Please select title{" "}
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                    <div className="col-sm-5">
                                      <label>Givenname</label>
                                      <input
                                        className="form-control"
                                        name="firstName"
                                        value={adult.firstName}
                                        onChange={(event) =>
                                          handleKidsChange(index, event)
                                        }
                                        required
                                        placeholder="Enter Givenname"
                                        type="text"
                                      />
                                      {errors.firstName === false ? (
                                        <div className="validationerror">
                                          Please enter givenname{" "}
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                    <div className="col-sm-5">
                                      <label>Surname</label>
                                      <input
                                        className="form-control"
                                        name="lastName"
                                        value={adult.lastName}
                                        onChange={(event) =>
                                          handleKidsChange(index, event)
                                        }
                                        required
                                        placeholder="Enter Surname"
                                        type="text"
                                      />
                                      {errors.lastName === false ? (
                                        <div className="validationerror">
                                          Please enter surname{" "}
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  </div>
                                </div>
                              ))}
                            {infantTravellers.length > 0 && infantTravellers.map((adult, index) =>
                              <div>
                                <p className="fw-600">INFANT {parseInt(index + 1)}</p>
                                <div className="row g-3 mb-4">
                                  <div className="col-sm-3">
                                    <label>Title</label>
                                    <select className="form-select" name="title" required value={adult.title} onChange={(event) => handleInfantChange(index, event)}>
                                      <option value="Ms">Ms</option>
                                      <option value="Master">Master</option>
                                    </select>
                                    {errors.title === false ? (<div className="validationerror">Please select title </div>) : ('')}
                                  </div>
                                  <div className="col-sm-3">
                                    <label>First Name</label>
                                    <input className="form-control" name="firstName" value={adult.firstName} onChange={(event) => handleInfantChange(index, event)} required placeholder="Enter First Name" type="text" />
                                    {errors.firstName === false ? (<div className="validationerror">Please enter firstName </div>) : ('')}
                                  </div>
                                  <div className="col-sm-3">
                                    <label>Last Name</label>
                                    <input className="form-control" name="lastName" value={adult.lastName} onChange={(event) => handleInfantChange(index, event)} required placeholder="Enter Last Name" type="text" />
                                    {errors.lastName === false ? (<div className="validationerror">Please enter lastName </div>) : ('')}
                                  </div>
                                  {params.isDomestic === 'INTERNATIONAL' ?
                                    <div className="col-sm-3">
                                      <label>Date Of Birth</label>
                                      <input className="form-control" name="dateOfBirth" value={adult.dateOfBirth} onBlur={(event) => validateInfantDate(index, event)} onChange={(event) => handleInfantChange(index, event)} required placeholder="Enter Date Of Birth" type="date" />
                                      {errors.dateOfBirth === false ? (<div className="validationerror">Please enter date of birth </div>) : ('')}
                                      {errorInfant && <div className="validationerror">{errorInfant}</div>}
                                    </div> : ""}
                                </div>

                              </div>
                            )}
                          </div>
                        </div>
                        <div className="full-width d-flex flex-column mb-2 position-relative">
                          <div className="row align-items-stat">
                            <div className="col-xl-12 col-lg-12 col-md-12 mb-2">
                              <h5>Personal Information</h5>
                            </div>
                            <div className="col-xl-6 col-lg-6 col-md-6">
                              <div className="form-group">
                                <label className="form-label">
                                  Email Address
                                </label>
                                <input
                                  type="text"
                                  maxLength={45}
                                  value={email}
                                  name="email"
                                  onChange={handleEmailChange}
                                  className="form-control"
                                  placeholder="Email Here"
                                />
                                {errors.email === false ? (
                                  <div className="validationerror">
                                    Please enter email{" "}
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                            <div className="col-xl-6 col-lg-6 col-md-6">
                              <div className="form-group">
                                <label className="form-label">
                                  Mobile number
                                </label>
                                <input
                                  type="number"
                                  maxLength={12}
                                  value={mobile}
                                  name="mobile"
                                  onChange={handleMobileChange}
                                  className="form-control"
                                  placeholder="Mobile Number"
                                />
                                {errors.mobile === false ? (
                                  <div className="validationerror">
                                    Please enter mobile{" "}
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <aside className="col-lg-4 mt-4 mt-lg-0">
                      <div className="bg-white shadow-md rounded p-3 mb-4">
                        <div className="position-relative ps-4">
                          <div className="location-brief-line">
                            {" "}
                            <em className="location-brief-pickup" />{" "}
                            <em className="location-brief-dropoff" />{" "}
                          </div>
                          <h6 className="text-4 mb-2">Name</h6>
                          <ul className="list-unstyled">
                            <li className="mb-1">{searchData.productName}</li>
                          </ul>
                        </div>
                        <div className="position-relative ps-4">
                          <div className="location-brief-line">
                            {" "}
                            <em className="location-brief-pickup" />{" "}
                            <em className="location-brief-dropoff" />{" "}
                          </div>
                          <h6 className="text-4 mb-2">Destination</h6>
                          <ul className="list-unstyled">
                            <li className="mb-1">{searchData.city}</li>
                          </ul>
                        </div>
                      </div>
                      <div className="bg-white shadow-md rounded p-3 sticky-top">
                        <h6 className="text-5 mb-3">Price Summary</h6>
                        <hr className="mx-n3" />
                        <ul className="list-unstyled">
                          <li className="mb-2">
                            Price{" "}
                            <span className="float-end text-5 fw-500 text-dark">
                              {searchData.currencyCode} {searchData?.price}
                            </span>
                            <br />
                          </li>
                        </ul>
                        <hr />
                        <div className="text-dark text-4 fw-500 my-4">
                          {" "}
                          Total Amount
                          <span className="float-end text-9">
                            {searchData.currencyCode} {searchData.totalPrice}
                          </span>
                        </div>
                        <hr />
                        <li className="mb-2 mt-3">
                          <div className="d-flex align-items-center justify-content-between">
                            <label className="mb-0">Add Markup</label>
                            <div style={{ width: '150px' }}>
                              <div className="input-group input-group-mb">
                                <span className="input-group-text">INR</span>
                                <input
                                  type="number"
                                  className="form-control text-end"
                                  value={markup}
                                  onChange={(e) => setMarkup(e.target.value >= 0 ? parseFloat(e.target.value) : 0)}
                                  min="0"
                                  placeholder="0"
                                />
                              </div>
                            </div>
                          </div>
                        </li>
                        <hr />
                        <div className="d-grid">
                          <button
                            className="btn btn-primary"
                            type="submit"
                            onClick={handleSubmit}
                          >
                            Book Now
                          </button>
                        </div>
                        <p className="text-danger text-center mt-3 mb-1">
                          <i className="far fa-clock" /> Last Booked - 6 hours
                          ago
                        </p>
                      </div>
                      {/* Price Summary End */}
                    </aside>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SightSeeingBooking;
